// Geometry of the chip rail slots (TERMINAL.md §6.3), as shares of the rail. Pure.

export const RAIL_SLOTS = 5;
/** Slots span this share of the rail width, starting RAIL_LEFT (share of width) left of its centre. */
export const RAIL_SPAN = 0.97;
export const RAIL_LEFT = 0.485;
/** Cartridge size in texels (face 64×88 plus the body rim). */
export const CHIP_TEXELS_W = 68;
export const CHIP_TEXELS_H = 94;
